import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const roleInValueChainApi = createApi({
    reducerPath: "roleInValueChainApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["RoleInalueChain"],
    endpoints: (builder) => ({
        // Get all Waste Streams
        getRoleInValueChain: builder.query({
            query: () => "/roles-in-value-chain",
            transformResponse: (response) => response.data || response,
            providesTags: ["RoleInalueChain"],
        }),

        // Get a single Waste Stream
        getRoleInValueChainById: builder.query({
            query: (id) => `/roles-in-value-chain/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: "RoleInValueChain", id }],
        }),

        // Create a new Waste Stream
        createRoleInValueChain: builder.mutation({
            query: (roleInValueChain) => ({
                url: `/roles-in-value-chain`,
                method: "POST",
                body: roleInValueChain,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["RoleInValueChain"],
        }),

        // Update an existing Waste Stream
        updateRoleInValueChain: builder.mutation({
            query: ({ id, ...roleInValueChain }) => ({
                url: `/roles-in-value-chain/${id}`,
                method: "PUT",
                body: roleInValueChain,
            }),
            invalidatesTags: ["RoleInValueChain"],
        }),

        // Delete an existing Waste Stream
        deleteRoleInValueChain: builder.mutation({
            query: (id) => ({
                url: `/roles-in-value-chain/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["RoleInValueChain"],
        }),
    }),
});

export const {
    useGetRoleInValueChainQuery,
    useGetRoleInValueChainByIdQuery,
    useCreateRoleInValueChainMutation,
    useUpdateRoleInValueChainMutation,
    useDeleteRoleInValueChainMutation,
} = roleInValueChainApi;